import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnimationUndershoot: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="animation-undershoot"><path d="M3.75 15.0938C4.3 17.1562 4.3 20.25 6.5 20.25C10.9 20.25 9.25 3.75 20.25 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAnimationUndershoot;
